import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PayerService } from '../../payer.service';
import { Note } from '../../payer';

@Component({
    selector: 'app-add-plan-notes-modal',
    templateUrl: './add-plan-notes-modal.component.html',
    styleUrls: ['./add-plan-notes-modal.component.scss'],
    standalone: false
})
export class AddPlanNotesModalComponent implements OnInit {
  @Input() activePlanId: string;
  @Output() public onCreate: EventEmitter<Note> = new EventEmitter();
  note = {
    content: ''
  };
  submitted = false;
  constructor(public modalRef: BsModalRef, private payerService: PayerService) { }

  ngOnInit() {
  }

  disabled() {
    return (!this.note.content || this.submitted);
  }

  createNote() {
    this.submitted = true;
    this.payerService.createActivePlanNotes(this.activePlanId, this.note)
      .subscribe((response:any) => {
        this.onCreate.emit(<Note>response.data);
        this.modalRef.hide();
      });
  }
}
